module.exports = __webpack_public_path__ + "static/AkzidGroProBolExt.f3abe91c.woff";